import "./styles.scss";

import { notification } from "antd";
import React, { useEffect, useState } from "react";
import { useOutletContext, useParams } from "react-router-dom";

import { settingsRecordsPerPage } from "../../config";
import { ENTITY_TYPE } from "../../constants/phase";
import amplitude from "../../externals/amplitude";
import { getEntityType } from "../../helpers";
import AddChannel from "./partialsSetting/AddChannel";
import AddClients from "./partialsSetting/AddClients";
import AddContentCategory from "./partialsSetting/AddContentCategory";
import AddCustomField from "./partialsSetting/AddCustomField";
import AddEvent from "./partialsSetting/AddEvent";
import AddFolder from "./partialsSetting/AddFolder";
import AddPackage from "./partialsSetting/AddPackage";
import AddPlayer from "./partialsSetting/AddPlayer";
import AddReservedChanel from "./partialsSetting/AddReservedChannle";
import AddShow from "./partialsSetting/AddShow";
import AddStorage from "./partialsSetting/AddStorage";
import AddSubClients from "./partialsSetting/AddSubClients";
import AddTeam from "./partialsSetting/AddTeam";
import AddTournament from "./partialsSetting/AddTournament";
import ClientWebHook from "./partialsSetting/ClientWebHook";
import ExportStreamIdCsv from "./partialsSetting/ExportStreamIdCsv";
import ExportYoutbeCsv from "./partialsSetting/ExportYoutbeCsv";
import MediaLiveTemplate from "./partialsSetting/MediaLiveTemplate";
import SrtEcryption from "./partialsSetting/SrtEcryption";
import ThirdPartyIntegration from "./partialsSetting/ThirdPartyIntegration";
const SettingComponent = (props) => {
  const {
    createRTMPChannel,
    updateRTMPState,
    getSportsDetail,
    deleteCategory,
    getCustomFields,
    createCustomFields,
    deleteFields,
    fetchSportsTeam,
    addEvent,
    createPlayer,
    fetchTournamentsData,
    deletePlayers,
    getEventStream,
    getPlayerStream,
    getPlayersByEvents,
    createStorage,
    getStorage,
    deleteStorage,
    editStorageDetails,
    getUserDetail,
    fetchMe,
    updateCustomFields,
    getEventsByCategory,
    addBulkTournament,
    addTagThroughCSV,
    addBulkTeam,
    getUsersByUserIds,
    addShow,
    getShows,
    deleteShows,
    editShow,
    uploadStoryTemplate,
    getStoryTemplates,
    testStoryTemplate,
    moveStoryTemplate,
    deleteStoryTemplate,
    getCategoryConfiguration,
    storageValidation,
    getStorageList,
    getAssignedUserOfStorage,
    addTenant,
    updateTenant,
    deleteTenant,
    getTenant,
    createStorageAdmin,
    editStorageDetailsAdmin,
    deleteStorageAdmin,
    deleteRTMPChannel,
    getRTMPChannel,
    updatertmpChannel,
    getChannelDetails,
    updateClientSetting,
    getClientSetting,
    importS3GlacierStreams,
    getDownloadVideosCSV,
    getYoutubeDownloadVideosData,
    createReservedChannle,
    listReservedChannel,
    deleteReservedChannel,
    addMediaTemplate,
    getMediaTemplate,
    editMediaTemplate,
    deleteMediaTemplate,
    getOrganizationsByIds,
    fetchSecretValues,
    deleteSecretValue,
    getCreateCategory,
    getAllTagsById,
    deleteTagsById,
    getCreateTeams,
    getAllTeams,
    deleteTeamById,
    editTeamById,
    getAssignedStorageOrganization,
    getOrganizationStorage,
    getCreateTournament,
    getAllTournament,
    getEditTournament,
    getDeleteTournament,
    getTotalTeams,
    editReservedChannel,
    getAllCategory,
    getOrgDetails,
    active_tab,
    active,
    selectedCategories,
    updateStorageMultipleFolderPath,
    fetchBrightCoveToken,
    syncTv2PlayerData,
    fetchTemplateConfig,
  } = props;

  const { entityId, parentClientSetting, clientSetting, user } = useOutletContext();
  const { id } = useParams();

  const [userId] = useState(localStorage.getItem("__uid"));
  const [sports, setSports] = useState([]);
  const [loder, setLoder] = useState(false);
  const [customData, setCustomData] = useState([]);
  const [tournamentList, setTournamentList] = useState([]);
  const [storageDetail, setStorageDetail] = useState([]);
  const [userData, setUserData] = useState({});
  const [count, setCount] = useState(0);
  const [search, setSearch] = useState("");
  //   const [currentItem, setCurrentItem] = useState({});
  const [usersDetails, setUsersDetails] = useState([]);
  const [userSearch, setUserSearch] = useState();
  const [selectedUser, setSelectedUser] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [tournamentCount, setTournamentCount] = useState("");
  //show message when data already exists
  const [notify, setNotify] = useState(false);
  //disable add button when user create a storage.
  const [addDisable, setAddDisable] = useState(true);
  //it is key to pass in validation storage-api
  const [allowAcl, setAllowAcl] = useState("no");
  //This state check the validating the existing storage or new storage
  const [isExistingStorage, setIsExistingStorage] = useState(false);
  //This state handle the storage  type when user create new storage
  const [storage, setStorage] = useState("aws");
  //validation button loader
  const [validateLoder, setValidateLoader] = useState(false);
  const [tenantNames, setTenantNames] = useState([]);
  const [tenantDetails, setTenantDetails] = useState({});
  const [getCategorys, setCategorys] = useState([]);
  const [validateValues, setValidateValues] = useState("");
  //old api to get categorys
  const getSoports = async () => {
    const { value } = await getSportsDetail({ userId });
    if (value?.success) {
      setSports(value?.data?.sports);
    } else {
      setSports([]);
    }
  };

  const getAllCategorys = async () => {
    if (id) {
      const { value } = await getAllCategory({
        entityId: id,
      });
      if (value?.success) {
        setCategorys(value.data);
      }
    }
  };
  const getCustomField = async () => {
    if (id) {
      const { value } = await getCustomFields({ entityId: id });
      if (value.success) {
        setCustomData(value?.setting?.customFields);
      }
    }
  };

  const mastersAdded = (message) => {
    notification["success"]({ message: message });
  };

  const fetchData = async () => {
    const { value } = await fetchMe();
    setUserData(value.data);
  };

  const addCustomField = async (payload) => {
    setLoder(true);
    const {
      value: { success, message },
    } = await createCustomFields(payload);
    if (success) {
      mastersAdded(message);
    } else {
      notification["error"]({ message: message });
    }
    setLoder(false);
    getCustomField();
  };

  const deleteField = async (payload) => {
    setLoder(true);
    const data = await deleteFields(payload);
    if (data.value.success) {
      mastersAdded("Setting deleted successfully");
    } else {
      mastersAdded(data.value.message);
    }
    setLoder(false);
    getCustomField();
  };

  const createEvent = async (payload) => {
    setLoder(true);
    const data = await addEvent(payload);
    if (data.value.success) {
      mastersAdded(data.value.message);
    } else {
      notification["error"]({ message: data.value.message });
    }
    setLoder(false);
  };

  const addPlayer = async (payload) => {
    setLoder(true);
    const data = await createPlayer(payload);
    if (data.value.success) {
      mastersAdded(data.value.message);
    } else {
      notification["error"]({ message: data.value.message });
    }
    setLoder(false);
  };

  // get tournaments by events
  const getTournaments = async (payload) => {
    const { value } = await getAllTournament(payload);
    if (value?.success) {
      setTournamentCount(value?.totalCount);
      setTournamentList(value.tournament);
    }
  };

  const deletePlayerData = async (name, event) => {
    setLoder(true);
    const data = await deletePlayers({
      playerName: name,
      sportName: event,
      userId,
    });
    if (data.value.success) {
      mastersAdded(data.value.message);
    }
    setLoder(false);
  };

  const fetchUserRole = async () => {
    const value = await fetchMe();
    if (value.value.status) {
      setUserData(value.value.data);
    }
  };
  const getInviteUser = async (status, array) => {
    const value = await getUserDetail({ search: userSearch, role: array });
    if (value.value.success) {
      setUsersDetails(value.value.users);
      // const filterUser = value.value.users.filter((d) => !d.hasOwnProperty("clientId"));
      // setUsersDetails(filterUser);
    }
  };
  useEffect(() => {
    getCustomField();
    fetchUserRole();
    fetchData();
    getTenants();
    getInviteUser(true);
    getAllCategorys();
  }, [id]);
  useEffect(() => {
    getSoports();
  }, [userId]);

  const fetchUsersByUserIds = async (userIds) => {
    const data = await getUsersByUserIds({
      userIds,
    });
    if (data?.value.success) {
      setAllUsers(data.value.data);
    }
  };
  //Validation Api for storage
  const handleValidate = async (values, resetForm) => {
    setAddDisable(true);
    setValidateLoader(true);
    const data = await storageValidation({
      ...values,
      isExistingStorage: isExistingStorage,
      storageType: storage,
    });
    resetForm({ values });
    if (data?.value?.status) {
      notification["success"]({ message: data?.value?.message });
      setAddDisable(false);
      setValidateLoader(false);
    } else {
      notification["error"]({ message: data?.value?.message });
      setAddDisable(true);
      setValidateLoader(false);
    }
  };
  const getTenants = async () => {
    const data = await getTenant({ userId });
    setTenantNames(data.value.data);
  };

  useEffect(() => {
    amplitude.logEvent("settings_viewed");
  }, []);
  const getEntityTypes = () => {
    return getEntityType(id);
  };
  useEffect(() => {
    getEntityTypes(id);
  }, [id]);

  useEffect(() => {
    setSearch("");
  }, [active_tab]);

  return (
    <>
      {active_tab === "category" && active && (
        <AddContentCategory
          sports={sports}
          loder={loder}
          userId={userId}
          userData={userData}
          settingsRecordsPerPage={settingsRecordsPerPage}
          getAllCategory={getAllCategory}
          getCreateCategory={getCreateCategory}
          deleteCategory={deleteCategory}
          getCategorys={getCategorys}
          id={id}
          selectedCategories={selectedCategories}
          userRole={user?.role}
          ENTITY_TYPE={ENTITY_TYPE}
        />
      )}
      {active_tab === "customFields" && (
        <AddCustomField
          userId={userId}
          createCustomFields={createCustomFields}
          setLoder={setLoder}
          updateCustomFields={updateCustomFields}
          customData={customData}
          loder={loder}
          deleteField={deleteField}
          settingsRecordsPerPage={settingsRecordsPerPage}
          id={id}
          getEntityTypes={getEntityTypes}
          ENTITY_TYPE={ENTITY_TYPE}
          getCustomField={getCustomField}
          mastersAdded={mastersAdded}
        />
      )}
      {active_tab === "folder" && (
        <AddFolder
          settingsRecordsPerPage={settingsRecordsPerPage}
          userData={userData}
          tenantNames={tenantNames}
          setTenantNames={setTenantNames}
          id={id}
          getEntityTypes={getEntityTypes}
          ENTITY_TYPE={ENTITY_TYPE}
          {...props}
        />
      )}
      {active_tab === "event" && (
        <AddEvent
          sports={sports}
          createEvent={createEvent}
          userId={userId}
          loder={loder}
          getEventStream={getEventStream}
          getEventsByCategory={getEventsByCategory}
          setLoder={setLoder}
          addTagThroughCSV={addTagThroughCSV}
          settingsRecordsPerPage={settingsRecordsPerPage}
          getAllCategory={getAllCategory}
          getCategorys={getCategorys}
          getAllTagsById={getAllTagsById}
          deleteTagsById={deleteTagsById}
          id={id}
          selectedCategories={selectedCategories}
          getEntityTypes={getEntityTypes}
          ENTITY_TYPE={ENTITY_TYPE}
        />
      )}
      {active_tab === "tournament" && (
        <AddTournament
          sports={sports}
          userId={userId}
          loder={loder}
          getTournaments={getTournaments}
          tournamentList={tournamentList}
          addBulkTournament={addBulkTournament}
          setSearch={setSearch}
          setCount={setCount}
          count={count}
          search={search}
          setTournamentList={setTournamentList}
          fetchTournamentsData={fetchTournamentsData}
          settingsRecordsPerPage={settingsRecordsPerPage}
          getAllCategory={getAllCategory}
          getCategorys={getCategorys}
          getCreateTournament={getCreateTournament}
          getAllTournament={getAllTournament}
          getAllTeams={getAllTeams}
          getEditTournament={getEditTournament}
          getDeleteTournament={getDeleteTournament}
          getTotalTeams={getTotalTeams}
          id={id}
          selectedCategories={selectedCategories}
          tournamentCount={tournamentCount}
          getEntityTypes={getEntityTypes}
          ENTITY_TYPE={ENTITY_TYPE}
        />
      )}
      {active_tab === "team" && (
        <AddTeam
          sports={sports}
          userId={userId}
          loder={loder}
          addBulkTeam={addBulkTeam}
          getPlayersByEvents={getPlayersByEvents}
          setSearch={setSearch}
          setCount={setCount}
          count={count}
          search={search}
          fetchSportsTeam={fetchSportsTeam}
          settingsRecordsPerPage={settingsRecordsPerPage}
          getAllCategory={getAllCategory}
          getCategorys={getCategorys}
          getCreateTeams={getCreateTeams}
          getAllTeams={getAllTeams}
          deleteTeamById={deleteTeamById}
          editTeamById={editTeamById}
          getAllTagsById={getAllTagsById}
          id={id}
          selectedCategories={selectedCategories}
          getEntityTypes={getEntityTypes}
          ENTITY_TYPE={ENTITY_TYPE}
        />
      )}
      {active_tab === "player" && (
        <AddPlayer
          sports={sports}
          userId={userId}
          addPlayer={addPlayer}
          loder={loder}
          deletePlayerData={deletePlayerData}
          getPlayerStream={getPlayerStream}
          getPlayersByEvents={getPlayersByEvents}
          addTagThroughCSV={addTagThroughCSV}
          setSearch={setSearch}
          setCount={setCount}
          count={count}
          search={search}
          setLoder={setLoder}
          settingsRecordsPerPage={settingsRecordsPerPage}
          getAllCategory={getAllCategory}
          getCategorys={getCategorys}
          getAllTagsById={getAllTagsById}
          deleteTagsById={deleteTagsById}
          id={id}
          addEvent={addEvent}
          selectedCategories={selectedCategories}
          getEntityTypes={getEntityTypes}
          ENTITY_TYPE={ENTITY_TYPE}
          syncTv2PlayerData={syncTv2PlayerData}
        />
      )}
      {active_tab === "rtmp" && (
        <AddChannel
          userId={userId}
          loder={loder}
          user={user}
          getChannelDetails={getChannelDetails}
          updatertmpChannel={updatertmpChannel}
          updateRTMPState={updateRTMPState}
          setLoder={setLoder}
          allUsers={allUsers}
          notify={notify}
          setNotify={setNotify}
          setAllUsers={setAllUsers}
          settingsRecordsPerPage={settingsRecordsPerPage}
          fetchUsersByUserIds={fetchUsersByUserIds}
          deleteRTMPChannel={deleteRTMPChannel}
          getRTMPChannel={getRTMPChannel}
          createRTMPChannel={createRTMPChannel}
          getInviteUser={getInviteUser}
          usersDetails={usersDetails}
          userSearch={userSearch}
          setUserSearch={setUserSearch}
          getOrgDetails={getOrgDetails}
          getOrganizationsByIds={getOrganizationsByIds}
          id={id}
          ENTITY_TYPE={ENTITY_TYPE}
        />
      )}
      {active_tab === "storage" && (
        <AddStorage
          sports={sports}
          userId={userId}
          addPlayer={addPlayer}
          loder={loder}
          setLoder={setLoder}
          deletePlayerData={deletePlayerData}
          getPlayerStream={getPlayerStream}
          getPlayersByEvents={getPlayersByEvents}
          createStorage={createStorage}
          getStorage={getStorage}
          setStorageDetail={setStorageDetail}
          storageDetail={storageDetail}
          deleteStorage={deleteStorage}
          editStorageDetails={editStorageDetails}
          clientSetting={clientSetting}
          parentClientSetting={parentClientSetting}
          storageValidation={storageValidation}
          validateValues={validateValues}
          setValidateValues={setValidateValues}
          addDisable={addDisable}
          setAddDisable={setAddDisable}
          handleValidate={handleValidate}
          allowAcl={allowAcl}
          setAllowAcl={setAllowAcl}
          setIsExistingStorage={setIsExistingStorage}
          storage={storage}
          setStorage={setStorage}
          validateLoder={validateLoder}
          setValidateLoader={setValidateLoader}
          user={user}
          getStorageList={getStorageList}
          usersDetails={usersDetails}
          setUserSearch={setUserSearch}
          getInviteUser={getInviteUser}
          selectedUser={selectedUser}
          setSelectedUser={setSelectedUser}
          userSearch={userSearch}
          getAssignedUserOfStorage={getAssignedUserOfStorage}
          fetchUsersByUserIds={fetchUsersByUserIds}
          allUsers={allUsers}
          setAllUsers={setAllUsers}
          createStorageAdmin={createStorageAdmin}
          editStorageDetailsAdmin={editStorageDetailsAdmin}
          deleteStorageAdmin={deleteStorageAdmin}
          getAssignedStorageOrganization={getAssignedStorageOrganization}
          getOrganizationStorage={getOrganizationStorage}
          updateStorageMultipleFolderPath={updateStorageMultipleFolderPath}
          id={id}
          syncTv2PlayerData={syncTv2PlayerData}
        />
      )}
      {active_tab === "show" && (
        <AddShow
          loder={loder}
          editShow={editShow}
          setLoder={setLoder}
          addShow={addShow}
          getShows={getShows}
          deleteShows={deleteShows}
          userId={userId}
          notify={notify}
          setNotify={setNotify}
          settingsRecordsPerPage={settingsRecordsPerPage}
        />
      )}
      {active_tab === "client-webhook" && (
        <ClientWebHook updateClientSetting={updateClientSetting} getClientSetting={getClientSetting} id={id} />
      )}
      {active_tab === "package" && <AddPackage settingsRecordsPerPage={settingsRecordsPerPage} id={id} {...props} />}
      {user.role === "superadmin" && (
        <>
          {active_tab === "clients" && (
            <AddClients
              getTenant={getTenant}
              tenantNames={tenantNames}
              setTenantNames={setTenantNames}
              addTenant={addTenant}
              updateTenant={updateTenant}
              deleteTenant={deleteTenant}
              userData={userData}
              setTenantDetails={setTenantDetails}
              tenantDetails={tenantDetails}
              loder={loder}
              setLoder={setLoder}
              usersDetails={usersDetails}
              userSearch={userSearch}
              setUserSearch={setUserSearch}
              getUserDetail={getUserDetail}
              setUsersDetails={setUsersDetails}
              {...props}
            />
          )}
        </>
      )}
      {userData.hasOwnProperty("clientId") && user.role === "admin" && (
        <>
          {active_tab === "subclients" && (
            <AddSubClients
              getTenants={getTenants}
              tenantNames={tenantNames}
              setTenantNames={setTenantNames}
              addTenant={addTenant}
              updateTenant={updateTenant}
              deleteTenant={deleteTenant}
              userData={userData}
              getUserDetail={getUserDetail}
              setTenantDetails={setTenantDetails}
              tenantDetails={tenantDetails}
              loder={loder}
              setLoder={setLoder}
              {...props}
            />
          )}
        </>
      )}
      {active_tab === "s3_glacier_restore" && (
        <ExportStreamIdCsv loder={loder} setLoder={setLoder} importS3GlacierStreams={importS3GlacierStreams} />
      )}
      {active_tab === "upload_youtube_csv" && (
        <ExportYoutbeCsv
          loder={loder}
          setLoder={setLoder}
          importS3GlacierStreams={importS3GlacierStreams}
          getDownloadVideosCSV={getDownloadVideosCSV}
          getYoutubeDownloadVideosData={getYoutubeDownloadVideosData}
        />
      )}
      {active_tab === "reserved-channel" && (
        <AddReservedChanel
          userId={userId}
          loder={loder}
          user={user}
          setLoder={setLoder}
          allUsers={allUsers}
          notify={notify}
          setNotify={setNotify}
          setAllUsers={setAllUsers}
          settingsRecordsPerPage={settingsRecordsPerPage}
          fetchUsersByUserIds={fetchUsersByUserIds}
          getInviteUser={getInviteUser}
          usersDetails={usersDetails}
          userSearch={userSearch}
          setUserSearch={setUserSearch}
          createReservedChannle={createReservedChannle}
          listReservedChannel={listReservedChannel}
          deleteReservedChannel={deleteReservedChannel}
          editReservedChannel={editReservedChannel}
          getOrganizationsByIds={getOrganizationsByIds}
          getOrgDetails={getOrgDetails}
        />
      )}
      {active_tab === "output_video_template" && (
        <MediaLiveTemplate
          userId={userId}
          loder={loder}
          setLoder={setLoder}
          notify={notify}
          setNotify={setNotify}
          getStorage={getStorage}
          storageDetail={storageDetail}
          setStorageDetail={setStorageDetail}
          addMediaTemplate={addMediaTemplate}
          getMediaTemplate={getMediaTemplate}
          editMediaTemplate={editMediaTemplate}
          deleteMediaTemplate={deleteMediaTemplate}
          listReservedChannel={listReservedChannel}
          entityId={entityId}
          getOrgDetails={getOrgDetails}
          fetchTemplateConfig={fetchTemplateConfig}
        />
      )}
      {active_tab === "srt_encryption" && (
        <SrtEcryption
          fetchSecretValues={fetchSecretValues}
          deleteSecretValue={deleteSecretValue}
          loader={loder}
          setLoader={setLoder}
        />
      )}
      {active_tab === "add_brightcove_user" && (
        <ThirdPartyIntegration entityId={entityId} fetchBrightCoveToken={fetchBrightCoveToken} />
      )}
    </>
  );
};

export default SettingComponent;
